import React, {
    Component,
} from 'react';

// Will remove this when migrating calibration
const setGlobalSelectedIndex = (index) => {
    window.insuranceGoalOwnerIndex = index;
};

export default class OwnerDropdownView extends Component {

    render() {
        const {
            selectedLabel,
            selectedIndex,
            options,
            setSelectedIndex,
        } = this.props;
        //TO DO: Remove this when moving calibration to react
        setGlobalSelectedIndex(selectedIndex);

        return <div className="NewFinancialPlanOwnerSelector has-dropdown">
            <span className="title">{selectedLabel}</span>
            <i className="fa fa-caret-down"/>

            <ul className="adv-dropdown">
                {
                    options.map(
                        (option, index) => {
                            if (index === selectedIndex) {
                                return <li className="selected">{selectedLabel}</li>;
                            }
                            return <li onClick={setSelectedIndex(index)}>{option}'s Insurance</li>;
                        }
                    )
                }
            </ul>
            <div className="placeholder">Select an insurance analysis</div>
        </div>
    }
};